/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Tools_Categories_TitleInputs */

const en_directory_tools_categories_title = /** @type {(inputs: Directory_Tools_Categories_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Browse categories`)
};

const zh_directory_tools_categories_title = /** @type {(inputs: Directory_Tools_Categories_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`浏览分类`)
};

/**
* | output |
* | --- |
* | "Browse categories" |
*
* @param {Directory_Tools_Categories_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_tools_categories_title = /** @type {((inputs?: Directory_Tools_Categories_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Tools_Categories_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_tools_categories_title(inputs)
	return zh_directory_tools_categories_title(inputs)
});
export { directory_tools_categories_title as "directory.tools.categories.title" }